import { render, staticRenderFns } from "./StaffNewPage.vue?vue&type=template&id=6f069f08&"
import script from "./StaffNewPage.vue?vue&type=script&lang=ts&"
export * from "./StaffNewPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports